import React from 'react';
import Inventory from "../components/inventory/Inventory";
import InventoryDashboard from '../components/inventory/InventoryDashboard';
import InventoryModule from '../components/inventory/InventoryModule';

const InventoryPage = () => {
    return (
        <div>
            <InventoryModule />
        </div>
    );
};

export default InventoryPage;
